// extracted by mini-css-extract-plugin
module.exports = {"container":"_1vPSrwC6zymIZhOh9mnmhi","groupsList":"_1aWyPKhQQbu2XE2BU_RzSb"};